import * as React from "react";
const SvgMicrosoftOutlook = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  fill: "#0A2767",
  d: "M23 12.5a.48.48 0 0 0-.234-.412h-.003l-.01-.005-7.622-4.41a1.045 1.045 0 0 0-1.143 0l-7.624 4.41-.009.005a.48.48 0 0 0 .012.831l7.623 4.41q.05.032.102.06a1.05 1.05 0 0 0 1.041-.06l7.623-4.41A.48.48 0 0 0 23 12.5"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#0078D4",
  d: "M7.14 5h5.116v4.5H7.14z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#MicrosoftOutlook_svg__a)",
  d: "m22.766 12.892-.01.005-7.623 4.19q-.05.03-.103.055-.197.091-.413.1l-.417-.238a1 1 0 0 1-.102-.057l-7.725-4.309h-.004l-.253-.138v8.482A1.037 1.037 0 0 0 7.172 22H21.96q.012-.002.025-.004a1.3 1.3 0 0 0 .359-.073q.075-.03.143-.073c.035-.019.093-.06.093-.06.262-.19.418-.49.419-.808V12.5c0 .162-.09.312-.234.392"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#50D9FF",
  d: "M17.372 5h4.605v4.5h-4.605z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#0078D4",
  d: "M7 5h5v4H7z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#0364B8",
  d: "M7 3a1 1 0 0 1 1-1h13a1 1 0 0 1 1 1v2H7z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#28A8EA",
  d: "M12 5h5v4h-5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#0078D4",
  d: "M12 9h5v4h-5zM17 13h5v5h-5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#0364B8",
  d: "M12 13h5v5h-5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#50D9FF",
  d: "M17 5h5v4h-5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#28A8EA",
  d: "M17 9h5v4h-5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1490DF",
  d: "m22.766 12.892-.01.005-7.623 4.19q-.05.03-.103.056a1.09 1.09 0 0 1-1.04-.056l-7.624-4.19-.009-.005a.45.45 0 0 1-.24-.392v8.482A1.037 1.037 0 0 0 7.17 22h14.774A1.037 1.037 0 0 0 23 20.982V12.5c0 .162-.09.312-.234.392"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#28A8EA",
  d: "M7.186 22h14.758L6.116 12.5v8.453c0 .578.478 1.046 1.07 1.047"
}), /*#__PURE__*/React.createElement("rect", {
  width: 11,
  height: 10,
  x: 1,
  y: 7,
  fill: "url(#MicrosoftOutlook_svg__b)",
  rx: 1
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M3.814 10.375a2.7 2.7 0 0 1 1.072-1.157 3.3 3.3 0 0 1 1.702-.417 3.07 3.07 0 0 1 1.575.396c.45.262.812.646 1.042 1.105.252.506.377 1.063.366 1.625a3.7 3.7 0 0 1-.376 1.7A2.73 2.73 0 0 1 8.12 14.77a3.2 3.2 0 0 1-1.634.406 3.14 3.14 0 0 1-1.61-.4A2.7 2.7 0 0 1 3.82 13.67a3.4 3.4 0 0 1-.37-1.605c-.01-.583.114-1.16.364-1.69m1.142 2.715c.124.304.333.568.603.76a1.6 1.6 0 0 0 .941.278c.358.014.711-.087 1.005-.286.267-.193.47-.457.586-.761.128-.34.191-.7.186-1.062a3.2 3.2 0 0 0-.176-1.075 1.7 1.7 0 0 0-.567-.793 1.58 1.58 0 0 0-.996-.3c-.343-.008-.68.09-.963.28-.275.194-.488.46-.614.767a2.99 2.99 0 0 0-.004 2.193z"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "MicrosoftOutlook_svg__a",
  x1: 14.558,
  x2: 14.558,
  y1: 12.5,
  y2: 22,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#35B8F1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#28A8EA"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "MicrosoftOutlook_svg__b",
  x1: 2.911,
  x2: 9.112,
  y1: 6.349,
  y2: 18.164,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#1784D9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#107AD5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#0A63C9"
}))));
export default SvgMicrosoftOutlook;
//# sourceMappingURL=MicrosoftOutlook.js.map